import React, { Component } from 'react'
import styled from 'styled-components'
import mapValues from 'lodash/mapValues'
import isArray from 'lodash/isArray'
import omit from 'lodash/omit'

import Logic from './logic'

import IcInfo from 'components/EditDataModalV2/images/ic-info.component.svg'
import IcArrow from './images/ic-arrow.component.svg'
import IcChechSuccess from './images/ic-check-success.component.svg'
import IcAlert from './images/ic-alert.component.svg'

import Loading from 'components/Loading'
import ButtonOutlineV2 from '../ButtonOutlineV2'
import ButtonGradientV2 from '../ButtonGradientV2'
import MobileModalV2 from '../MobileModalV2'
import SmallModalV2 from '../SmallModalV2'

import PersonalForm from './mobileComponents/personalForm'
import SimplePersonalForm from './mobileComponents/simplePersonalForm'
import AddressForm from './mobileComponents/addressForm'
import Revision from './mobileComponents/revision'

import {
  isPhone,
  isEmail,
  required,
  isNIF,
  notEmptyEmail,
  notEmptyPhone,
  isContactPhone,
  hasBillingAddress,
  isChecked,
  hasPaidServices,
} from './validations'

const translateErrors = {
  first_name: 'Primeiro Nome',
  last_name: 'Último Nome',
  tax_id: 'NIF',
  email: 'Email',
  phone_number: 'Telefone / Telemóvel',
  company_phone_number: 'Telefone / Telemóvel Contacto',
  company_name: 'Nome da empresa',
  company_cae: 'CAE da empresa',
  company_email: 'Email empresa',
  legal_bi: 'BI/CC do Representante legal',
  street: 'Rua',
  door: 'Nº da porta',
  floor: 'Andar',
  postal_code: 'Código postal',
  billing_address: 'Morada de faturação',
  billing_street: 'Rua de faturação',
  billing_door: 'Nº da porta de faturação',
  billing_floor: 'Andar de faturação',
  billing_postal_code: 'Código postal de faturação',
  cpe: 'CPE',
  cui: 'CUI',
  cuicpe: ['CUI', 'CPE'],
}

@Logic
export default class JoinTariffModalMobileV2 extends Component {
  constructor() {
    super()
    this.state = {
      tabs: [],
      currentTab: '',
      isEleContract: false,
      currentTariff: null,
      open: false,
      errorOpened: true,
      showedDisclaimer: true,
      canSub: true,
      infoModal: false,
      validations: [],
    }

    this.adhereButtons = [
      {
        label: 'cancelar',
        primary: false,
        click: () => this.toggleModal(),
        color: '#006736',
      },
      {
        label: 'seguinte',
        primary: true,
        click: this.adhereActions,
      },
    ]
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      currentTariff: nextProps.tariff,
    })

    if (nextProps.tariffInfo) {
      const {
        tariff,
        values: { potencia_contratada, ciclo_tarifa, municipality },
        simulation,
      } = nextProps

      const { priceListTimeCycle } = this.props.tariff
      const isEleContract =
        nextProps.tariffInfo.pricelistadditionalinfo.electronic_contract
      isEleContract && this.setState({ tabs: ['simple_personal', 'revision'] })

      if (nextProps.firstSet) {
        if (tariff.suggested_electricity) {
          if (potencia_contratada) {
            this.changeField('electric', 'potency', potencia_contratada)
          }
          if (ciclo_tarifa) {
            this.changeField('electric', 'cycle', ciclo_tarifa)
          }
          if (priceListTimeCycle) {
            this.changeField('electric', 'tariff', priceListTimeCycle)
          }
        }

        if (simulation && simulation.gasStage) {
          this.changeField('gas', 'tier', simulation.gasStage)
        }

        if (municipality) {
          this.changeField('billing', 'municipality', municipality)
        }

        this.actions.setFirstSet(false)
      }
    }
  }

  componentWillMount() {
    const {
      tariff,
      values: { ciclo_tarifa },
      tariffInfo,
    } = this.props

    const {
      subscription_requires_email,
      subscription_requires_phone,
    } = tariffInfo.entity
    const {
      priceListTimeCycle,
      calculatedHiredPowerFactor,
      gasStage,
    } = this.props.tariff.result

    let eleSub = true
    let gasSub = true
    const isEleContract =
      !!tariffInfo && tariffInfo.pricelistadditionalinfo.electronic_contract
    this.setState({ isEleContract })

    if (tariff.result.electricityPriceList) {
      const {
        electricityPriceList: {
          entity: { can_subscribe: canSub },
        },
      } = tariff
      eleSub = canSub
    }
    if (tariff.result.gasPriceList) {
      const {
        gasPriceList: {
          entity: { can_subscribe: canSub },
        },
      } = tariff
      gasSub = canSub
    }
    if (!eleSub || !gasSub) {
      this.adhereButtons = [
        {
          label: 'Fechar',
          primary: true,
          click: () => this.toggleModal(),
        },
      ]
      this.setState({
        currentTariff: tariff,
        canSub: false,
        showedDisclaimer: true,
      })
    } else {
      if (tariff.result.electricityPriceList) {
        if (calculatedHiredPowerFactor) {
          const hiredPower = Number(calculatedHiredPowerFactor)
          this.changeField('electric', 'potency', hiredPower)
        }
        if (ciclo_tarifa) {
          this.changeField('electric', 'cycle', ciclo_tarifa)
        }
        if (priceListTimeCycle) {
          this.changeField('electric', 'tariff', priceListTimeCycle)
        }
      }

      if (tariff.result.gasPriceList) {
        if (gasStage) {
          this.changeField('gas', 'tier', gasStage)
        }
      }

      const personal = []
      if (isEleContract) {
        personal.push('simple_personal')
        this.setState({ currentTab: 'simple_personal' })
      } else {
        personal.push('personal')
        this.setState({ currentTab: 'personal' })
      }

      const billing = []
      if (!isEleContract) {
        billing.push('address')
      }

      const tabs = [...personal, ...billing, 'revision']

      let validations = []
      let personalValidations = {
        name: [required],

        surName: [required],

        nif: [required, isNIF],

        /*
         * these validations are added later now that
         * entities can control if email or phone are required
         */
        email: [],
        phone: [],

        contact: [required],

        contactTime: [[isContactPhone], required],
      }

      validations = [{ personal: personalValidations }]

      if (!isEleContract) {
        validations.push({
          billing: {
            street: [required],
            door: [required],
            district: [required],
            municipality: [required],
            billingStreet: [[hasBillingAddress], required],
            billingDoor: [[hasBillingAddress], required],
            billingDistrict: [[hasBillingAddress], required],
            billingMunicipality: [[hasBillingAddress], required],
          },
        })
      }

      if (isEleContract) {
        delete validations[0].personal.nif
      }

      const phone = validations[0].personal.phone
      const email = validations[0].personal.email
      if (subscription_requires_email && !email.length) {
        validations[0].personal.email.push(...[required, isEmail])
      }
      if (subscription_requires_phone && !phone.length) {
        validations[0].personal.phone.push(...[required, isPhone])
      }

      validations.push({
        confirm: {
          allowDataSharing: [isChecked],
        },
      })

      this.setState({ currentTariff: tariff, tabs, validations })
    }

    if (this.props.isHome) {
      this.changeField(
        'electric',
        'potency',
        parseFloat(this.props.tariff.calculatedHiredPowerFactor)
      )
      this.changeField('gas', 'tier', parseFloat(this.props.tariff.gasStage))
    }
  }

  componentWillUnmount() {
    this.setState({ currentTariff: null, tabs: [], currentTab: '' })
  }

  isFormValid = (validations) => {
    const key = Object.keys(validations)[0]
    const list = validations[key]
    const formBase = this.props.formValues[key]

    let invalid = { [key]: {} }
    mapValues(list, (funcs, valueKey) => {
      for (var index = 0; index < funcs.length; index++) {
        let func = funcs[index]
        let doFirst = true
        if (isArray(func)) {
          func = func[0]
          doFirst = false

          if (!func(formBase[valueKey].value, formBase)) {
            break
          }
        }
        if (doFirst) {
          if (formBase[valueKey]) {
            const { result, message } = func(formBase[valueKey].value, formBase)
            if (!result) {
              invalid[key][valueKey] = message
              break
            }
          }
        }
      }
    })

    if (this.props.tariffInfo && key === 'personal') {
      const {
        subscription_requires_email,
        subscription_requires_phone,
      } = this.props.tariffInfo.entity
      let emailKey = 'email'
      let phoneKey = 'phone'

      if (!subscription_requires_email && !subscription_requires_phone) {
        const phone = this.props.formData.personal[phoneKey]
        const email = this.props.formData.personal[emailKey]

        const emailVal = notEmptyEmail(email.value, phone.value)
        const phoneVal = notEmptyPhone(phone.value, email.value)

        if (!invalid.personal[phoneKey] && !emailVal.result) {
          invalid.personal[emailKey] = emailVal.message
        }
        if (!invalid.personal[emailKey] && !phoneVal.result) {
          invalid.personal[phoneKey] = phoneVal.message
        }
      }
    }
    return { valid: !Object.keys(invalid[key]).length, invalid }
  }

  toggleTab = (value) => {
    const { currentTab, validations } = this.state

    let valid = true
    let invalid
    if (currentTab === 'personal' || currentTab === 'simple_personal') {
      const validation = this.isFormValid(validations[0])
      valid = validation.valid
      invalid = validation.invalid
    } else if (currentTab === 'address' && value === 'revision') {
      const validation = this.isFormValid(validations[1])
      valid = validation.valid
      invalid = validation.invalid
    }

    if (valid) {
      this.setState({ currentTab: value })
    } else {
      this.actions.setInvalid(invalid)
    }
  }

  transformForm = (form) => {
    if (!form) {
      return false
    }

    const { personal, billing, electric, gas } = form
    const {
      name: first_name,
      surName: last_name,
      nif: tax_id,
      email,
      phone: phone_number,
      contact,
      contactTime,
    } = personal

    const {
      street,
      door,
      floor,
      district,
      municipality,
      billingDoor,
      billingFloor,
      billingDistrict,
      billingMunicipality,
      billingStreet,
      directDebit,
      electronicBilling,
      billingAddress,
    } = billing

    const {
      cpe,
      potency: hired_power,
      tariff: time_cycle,
      cycle: price_list_cycle,
    } = electric

    const { cui, tier: price_step } = gas

    const {
      id: price_list,
      entity,
      priceListObject,
      pricelistadditionalinfo,
    } = this.props.tariffInfo

    let gasFields = {
      current_gas_entity: entity.id,
      cui: cui.value,
      ...(price_step.value && { price_step: price_step.value }),
    }

    let eletricityFields = {
      current_electricity_entity: entity.id,
      cpe: cpe.value,
      price_list_cycle: price_list_cycle.value,
      ...(hired_power.value && { hired_power: hired_power.value }),
      ...(time_cycle.value && { time_cycle: time_cycle.value }),
    }

    // Subscription source
    let subscription_source = 'simple_simulator'

    const priceListId = priceListObject.priceListId

    // Set the personal object to the correct one based on simulator
    let personalObj = {
      first_name: first_name.value,
      last_name: last_name.value,
      tax_id: tax_id.value,
      email: email.value,
      phone_number: phone_number.value,
      contact: contact.value,
      contact_time: contactTime.value,
    }
    const isEleContract = !!(
      this.props.tariffInfo && pricelistadditionalinfo.electronic_contract
    )

    if (isEleContract) {
      personalObj = omit(personalObj, ['tax_id', 'contact'])
    }

    let obj = {
      ...personalObj,
      street: street.value,
      door: door.value,
      floor: floor.value,
      billing_street: billingStreet.value,
      billing_door: billingDoor.value,
      billing_floor: billingFloor.value,
      billing_detail: `${
        electronicBilling.value === 'false' ? '' : electronicBilling.value
      }${directDebit.value === 'false' ? '' : directDebit.value}`,
      billing_address: billingAddress.value,
      billing_district: billingDistrict.value,
      billing_municipality: billingMunicipality.value,
      contract_summary: {},
      price_list: price_list,
      user: '',
      district: district.value,
      municipality: municipality.value,
      subscription_source,
      simulation_price_list: priceListId,
    }

    if (this.state.currentTariff.result.electricityPriceList) {
      obj = { ...obj, ...eletricityFields }
    }

    if (this.state.currentTariff.result.gasPriceList) {
      obj = { ...obj, ...gasFields }
    }

    return obj
  }

  renderBtns = () => {
    const { currentTab, validations, isEleContract } = this.state
    const { formValues, confirmationError } = this.props
    const { submitForm, setConfirmationError } = this.actions

    let outlineBtnText = currentTab === 'personal' ? 'Cancelar' : 'Voltar atrás'
    let gradientBtnText = currentTab === 'revision' ? 'Aderir' : 'Seguinte'

    const handleOutlineClick = (e) => {
      e.preventDefault()

      if (confirmationError) {
        setConfirmationError(false)
        this.setState({ cancelModal: true })
        return
      }

      if (currentTab === 'personal' || currentTab === 'simple_personal') {
        this.setState({ cancelModal: true })
      } else if (currentTab === 'address') {
        this.toggleTab('personal')
      } else if (currentTab === 'revision' && isEleContract) {
        this.toggleTab('simple_personal')
      } else {
        this.toggleTab('address')
      }
    }

    const handleGradientClick = (e) => {
      e.preventDefault()

      if (confirmationError) {
        this.actions.submitForm(
          this.transformForm(this.props.formData),
          {
            omitRepeated: true,
          },
          this.setState({ successModal: true })
        )
        return
      }

      if (currentTab === 'personal' || currentTab === 'simple_personal') {
        const validation = this.isFormValid(validations[0])
        if (validation.valid) {
          this.toggleTab(currentTab === 'personal' ? 'address' : 'revision')
        } else {
          this.actions.setInvalid(validation.invalid)
        }
      } else if (currentTab === 'address') {
        const validation = this.isFormValid(validations[1])
        if (validation.valid) {
          this.toggleTab('revision')
        } else {
          this.actions.setInvalid(validation.invalid)
        }
      } else {
        const personalValid = this.isFormValid(validations[0])
        const billingValid = this.isFormValid(validations[1])
        const revisionValid = formValues.confirm.allowDataSharing.value

        if (personalValid.valid && billingValid.valid && revisionValid) {
          submitForm(
            this.transformForm(formValues),
            {},
            this.setState({ successModal: true })
          )
        }
      }
    }

    return (
      <BtnsWrapper tab={currentTab}>
        <div
          className='advice'
          onClick={() => this.setState({ infoModal: true })}>
          <IcInfo />
          <h4>Como Funciona?</h4>
        </div>
        <div className='btns'>
          <ButtonOutlineV2 onClick={(e) => handleOutlineClick(e)}>
            {outlineBtnText}
          </ButtonOutlineV2>
          <ButtonGradientV2
            onClick={(e) => handleGradientClick(e)}
            trailingIcon={<IcArrow />}
            disabled={this.disableSubmitButton()}>
            {gradientBtnText}
          </ButtonGradientV2>
        </div>
      </BtnsWrapper>
    )
  }

  closeModal = () => {
    const { changeTariff } = this.props
    const { resetForm } = this.actions

    resetForm()
    changeTariff(null)
  }

  toggleModal = (open = false) => {
    this.setState(
      { open },
      () =>
        !this.state.opened &&
        this.actions.reset() &&
        this.props.changeTariff(null)
    )
  }

  toggleErrorModal = () => {
    this.actions.setAdhesionError(null)
  }

  changeField = (key, property, value) => {
    const section = Object.assign({}, this.props.formValues[key])
    const field = Object.assign({}, section[property], { value })
    const data = Object.assign(this.props.formValues, {
      [key]: { ...section, [property]: field },
    })
    if (property === 'district' || property === 'billingDistrict') {
      this.actions.fetchMunicipalities(value, property)
    }
    this.actions.setFormValues(data)
  }

  errorsList(errors) {
    return Object.keys(errors).map((key) => {
      let field
      if (key === 'cuicpe') {
        field = (
          <div key={key}>
            Estes {translateErrors[key][0]} e {translateErrors[key][1]} aderiram
            a um tarifário recentemente. Tem de aguardar 30 dias para efetuar
            uma nova adesão no Poupa Energia. Se tiver dúvidas ligue-nos para o
            211 160 500.
          </div>
        )
      } else if (key === 'cui' || key === 'cpe') {
        field = (
          <div key={key}>
            Este {translateErrors[key]} aderiu a um tarifário recentemente. Tem
            de aguardar 30 dias para efetuar uma nova adesão no Poupa Energia.
            Se tiver dúvidas ligue-nos para o 211 160 500.
          </div>
        )
      } else {
        field = (
          <div key={key}>O campo {translateErrors[key]} contém erros.</div>
        )
      }
      return field
    })
  }

  keepOnPersonalTab = () => {
    const { validations } = this.state
    const validation = this.isFormValid(validations[0])

    if (validation.valid) {
      return false
    } else {
      return true
    }
  }

  keepOnAddressTab = () => {
    const { validations } = this.state
    const validation = this.isFormValid(validations[1])

    if (validation.valid) {
      return false
    } else {
      return true
    }
  }

  disableSubmitButton = () => {
    const { currentTab } = this.state
    const { formValues } = this.props

    if (currentTab === 'personal' || currentTab === 'simple_personal') {
      return this.keepOnPersonalTab()
    } else if (currentTab === 'address') {
      return this.keepOnAddressTab()
    } else if (currentTab === 'revision') {
      return !formValues.confirm.allowDataSharing.value
    }

    return false
  }

  renderLoading() {
    const { loading, submitting } = this.props
    return loading || submitting ? <Loading /> : null
  }

  renderSmallModal = (type) => {
    const { adhesionResponse } = this.props
    const condition =
      type === 'success'
        ? adhesionResponse && this.state.successModal
        : this.state.cancelModal
    const icon = type === 'success' ? <IcChechSuccess /> : <IcAlert />
    const title =
      type === 'success'
        ? 'Pré-adesão submetida com sucesso'
        : 'sair da página ?'
    const description =
      type === 'success' ? (
        <Description>
          O comercializador recebeu os seus dados e irá entrar em contacto
          consigo no prazo máximo de 48h. Enviámos uma confirmação do processo
          para o seu email:&nbsp;
          <b>{this.props.formValues.personal.email.value}</b>
        </Description>
      ) : (
        <Description>
          Se optar por sair agora, todos os dados que já preencheu serão
          perdidos e não poderão ser recuperados. Para evitar ter que reiniciar
          o processo, recomendamos que termine o preenchimento.
        </Description>
      )
    const btnsContent =
      type === 'success' ? (
        <ButtonGradientV2
          style={{ width: '100% ' }}
          onClick={() => {
            this.setState({ successModal: false })
            this.closeModal()
          }}>
          Ok
        </ButtonGradientV2>
      ) : (
        <SmallModalBtnsWrapper>
          <ButtonOutlineV2
            onClick={() => {
              this.setState({ cancelModal: false })
            }}>
            Cancelar
          </ButtonOutlineV2>
          <ButtonGradientV2
            danger
            style={{ flexGrow: '1' }}
            onClick={() => {
              this.setState({ cancelModal: false })
              this.closeModal()
            }}>
            Sair
          </ButtonGradientV2>
        </SmallModalBtnsWrapper>
      )

    const handleClose =
      type === 'success'
        ? () => {
            this.setState({ successModal: false })
            if (adhesionResponse) {
              this.closeModal()
            }
          }
        : () => this.setState({ cancelModal: false })

    return (
      condition && (
        <SmallModalV2
          title={title}
          description={description}
          icon={icon}
          onClose={handleClose}>
          {btnsContent}
        </SmallModalV2>
      )
    )
  }

  renderInfoModal = () => {
    return this.state.infoModal ? (
      <InfoModal onClose={() => this.setState({ infoModal: false })}>
        <InfoModalWrapper>
          <IcInfo />
          <h3>Como Funciona?</h3>
          <p>Complete o seu pedido de adesão e nós tratamos do resto!</p>
          <p>
            Iremos contactar o novo comercializador e enviar-lhe todos os dados
            necessários
          </p>
          <p>
            O novo comercializador irá contactá-lo para confirmar o seu pedido
            de adesão
          </p>
        </InfoModalWrapper>
      </InfoModal>
    ) : null
  }

  renderTab = (tab) => {
    const {
      adhesionResponse,
      confirmationError,
      tariffInfo,
      submitting,
    } = this.props
    const { showedDisclaimer, canSub } = this.state

    return !adhesionResponse &&
      !confirmationError &&
      showedDisclaimer &&
      canSub &&
      tariffInfo &&
      !submitting
      ? tab
      : null
  }

  render() {
    const { tabs, currentTab, isEleContract } = this.state
    const {
      formValues,
      loading,
      districts,
      municipalities,
      billingMunicipalities,
      electricityPriceList,
      gasPriceList,
      prices,
      tariffInfo,
      calculatedHiredPowerFactor,
      priceListTimeCycle,
      gasStage,
      translations,
    } = this.props

    const {
      ESCLARECIMENTO_CUSTOS_ADICIONAIS,
      ESCLARECIMENTO_CONTACTE,
      ESCLARECIMENTO_PONTO_4,
      ESCLARECIMENTO_PONTO_3,
      ESCLARECIMENTO_PONTO_2,
      ESCLARECIMENTO_PONTO_1,
      ESCLARECIMENTO_INDISPONIVEL,
    } = translations || {}

    return (
      <MobileModalV2
        setModalTriggerHeight={this.props.setModalTriggerHeight}
        modalTriggerHeight={this.props.modalTriggerHeight}
        title='Aderir ao Tarifário'
        onClose={() => this.setState({ cancelModal: true })}>
        <Content>
          <TableHeader>
            <TopRow>
              {tabs.map((tab, index) => {
                const suffix = `${index + 1}.`
                const text =
                  tab === 'revision'
                    ? 'Resumo'
                    : tab === 'address'
                    ? 'Morada'
                    : 'Dados Pessoais'
                let disableTab = false

                if (tab === 'address') {
                  disableTab = this.keepOnPersonalTab()
                } else if (tab === 'revision' && isEleContract) {
                  disableTab = this.keepOnPersonalTab()
                } else if (tab === 'revision' && !isEleContract) {
                  disableTab = this.keepOnAddressTab()
                }

                return (
                  <ToggleButton
                    key={`tab_${tab}`}
                    active={currentTab === tab}
                    onClick={() => this.toggleTab(tab)}
                    disabled={disableTab}>
                    {suffix} {text}
                  </ToggleButton>
                )
              })}
            </TopRow>
          </TableHeader>

          <FormWrapper>
            {this.renderLoading()}

            {this.renderTab(
              <PersonalForm
                name={formValues.personal.name}
                surName={formValues.personal.surName}
                email={formValues.personal.email}
                phone={formValues.personal.phone}
                nif={formValues.personal.nif}
                contact={formValues.personal.contact}
                contactTime={formValues.personal.contactTime}
                changeField={this.changeField}
                loading={loading}
                tab={currentTab}
                renderBtns={this.renderBtns}
              />
            )}
            {this.renderTab(
              <SimplePersonalForm
                name={formValues.personal.name}
                surName={formValues.personal.surName}
                email={formValues.personal.email}
                phone={formValues.personal.phone}
                changeField={this.changeField}
                loading={loading}
                tab={currentTab}
                renderBtns={this.renderBtns}
              />
            )}
            {this.renderTab(
              <AddressForm
                billingAddress={formValues.billing.billingAddress}
                directDebit={formValues.billing.directDebit}
                street={formValues.billing.street}
                door={formValues.billing.door}
                floor={formValues.billing.floor}
                district={formValues.billing.district}
                municipality={formValues.billing.municipality}
                billingStreet={formValues.billing.billingStreet}
                billingDoor={formValues.billing.billingDoor}
                billingFloor={formValues.billing.billingFloor}
                billingDistrict={formValues.billing.billingDistrict}
                billingMunicipality={formValues.billing.billingMunicipality}
                electronicBilling={formValues.billing.electronicBilling}
                districts={districts}
                municipalities={municipalities}
                billingMunicipalities={billingMunicipalities}
                changeField={this.changeField}
                loading={loading}
                tab={currentTab}
                renderBtns={this.renderBtns}
              />
            )}
            {this.renderTab(
              <Revision
                currentTariff={this.state.currentTariff}
                loading={loading}
                tab={currentTab}
                electricityPriceList={electricityPriceList}
                gasPriceList={gasPriceList}
                prices={prices}
                tariffInfo={tariffInfo}
                calculatedHiredPowerFactor={calculatedHiredPowerFactor}
                timeCycle={priceListTimeCycle}
                gasStage={gasStage}
                formValues={formValues}
                renderBtns={this.renderBtns}
                changeField={this.changeField}
                allowDataSharing={formValues.confirm.allowDataSharing}
                districts={districts}
                municipalities={municipalities}
                billingMunicipalities={billingMunicipalities}
              />
            )}

            {this.props.confirmationError && !this.props.adhesionResponse && (
              <SuccessMessage>
                <ConfirmationError>
                  {this.props.translations.CONFIRMATION_TIME_ERROR}
                </ConfirmationError>
              </SuccessMessage>
            )}

            {this.props.adhesionError && (
              <SmallModalV2
                icon={<IcAlert />}
                title='Aviso'
                onClose={() => this.actions.setAdhesionError(null)}>
                {this.props.adhesionError &&
                  this.props.adhesionError.response.data &&
                  !(
                    typeof this.props.adhesionError.response.data === 'string'
                  ) && (
                    <ApiErrors>
                      {this.errorsList(this.props.adhesionError.response.data)}
                    </ApiErrors>
                  )}
                {this.props.adhesionError &&
                  this.props.adhesionError.response.data &&
                  typeof this.props.adhesionError.response.data ===
                    'string' && (
                    <span>Ocorreu um erro, por favor tente novamente</span>
                  )}
              </SmallModalV2>
            )}

            {!this.state.showedDisclaimer && (
              <Disclaimer>
                <DisclaimerTitle>Esclarecimento</DisclaimerTitle>
                {this.props.tariffInfo &&
                  hasPaidServices(
                    this.props.tariffInfo.additional_services
                  ) && (
                    <DisclaimerText red>
                      {ESCLARECIMENTO_CUSTOS_ADICIONAIS}
                    </DisclaimerText>
                  )}

                <DisclaimerText>
                  <ListBall />
                  {ESCLARECIMENTO_PONTO_1}
                </DisclaimerText>
                <DisclaimerText>
                  <ListBall />
                  {ESCLARECIMENTO_PONTO_2}
                </DisclaimerText>
                <DisclaimerText>
                  <ListBall />
                  {ESCLARECIMENTO_PONTO_3}
                </DisclaimerText>
                <DisclaimerText>
                  <ListBall />
                  {ESCLARECIMENTO_PONTO_4}
                </DisclaimerText>
                <DisclaimerTitle>{ESCLARECIMENTO_CONTACTE}</DisclaimerTitle>
              </Disclaimer>
            )}

            {!this.state.canSub && (
              <Disclaimer>
                <DisclaimerTitle>Esclarecimentos</DisclaimerTitle>
                <DisclaimerText>{ESCLARECIMENTO_INDISPONIVEL}</DisclaimerText>
                <DisclaimerTitle>{ESCLARECIMENTO_CONTACTE}</DisclaimerTitle>
              </Disclaimer>
            )}
          </FormWrapper>
        </Content>
        {this.renderSmallModal('success')}
        {this.renderSmallModal('cancel')}
        {this.renderInfoModal()}
      </MobileModalV2>
    )
  }
}

const InfoModal = styled(SmallModalV2)`
  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);

  .closeIcon {
    fill: #fff;
    path {
      fill: #fff;
    }
  }
`

const InfoModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  > svg {
    width: 48px;
    height: 48px;
  }

  > h3,
  p {
    color: #fff;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px; /* 140% */
    margin: 0;
  }

  > h3 {
    text-transform: uppercase;
  }

  > p {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px; /* 150% */
  }
`

const SuccessMessage = styled.div`
  display: flex;
  flex-direction: column;
  padding: 50px;
  align-items: center;
  justify-content: center;

  img {
    width: 87px;
    height: 64px;
    margin-bottom: 50px;
  }
`

const ConfirmationError = styled.div`
  color: #010101;
  font-family: Nunito;
  font-size: 19px;
  line-height: 34px;
  text-align: center;
`

const ApiErrors = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  width: 100%;

  border: 1px solid #ececec;
`

const TableHeader = styled.div`
  width: 100%;
`

const TopRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`

const ToggleButton = styled.span`
  display: flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
  cursor: pointer;
  min-width: 150px;

  background: ${({ active }) => (active ? '#fff' : '#EFEFEF')};

  color: ${({ active }) => (active ? '#1D1E22' : '#3E3E3E')};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid #006736;
  `}

  ${({ disabled }) =>
    disabled &&
    `
    cursor: default;
  `}
`

const FormWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-self: stretch;
`

const BtnsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ tab }) =>
    tab !== 'personal' &&
    `
    width: 100%;  
  `}

  .advice {
    display: flex;
    padding: 8px 20px;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    background: var(
      --Gradient,
      linear-gradient(270deg, #006736 -58.87%, #93c13e 100%)
    );

    > h4 {
      color: #fff;
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px; /* 177.778% */
      text-transform: uppercase;
      margin: 0;
    }
  }

  .btns {
    display: flex;
    padding: 16px;
    align-items: center;
    gap: 12px;
    align-self: stretch;

    > div:first-child,
    > button {
      width: 100%;
    }
  }

  @media screen and (min-width: 600px) {
    .btns {
      justify-content: flex-end;

      > div:first-child,
      > button {
        width: 140px;
      }
    }
  }
`

const Disclaimer = styled.div`
  padding: 20px 0;
`

const DisclaimerTitle = styled.span`
  display: block;
  font-weight: bold;
  margin-bottom: 20px;
  color: #8abb3f;
`

const DisclaimerText = styled.div`
  margin-bottom: 10px;

  ${({ red }) =>
    red &&
    `
  color: indianred;
  `}
`

const ListBall = styled.div`
  width: 10px;
  height: 10px;
  background: linear-gradient(270deg, #006736 0%, #93c13e 100%);
  display: inline-block;
  border-radius: 50%;
  margin-right: 10px;
`

const Description = styled.p`
  align-self: stretch;
  color: #3e3e3e;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin: 0;

  > b {
    color: #010101;
    font-weight: 700;
  }
`

const SmallModalBtnsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
`



// WEBPACK FOOTER //
// ./src/components/JoinTariffModalV2/mobile.js